const data = {
  fastcompany: {
    logo:
      '//a.fastcompany.net/image/upload/v1488299125/fc/fastcompany-logo.svg',
    title: 'Fast Company',
    subscribeLink: 'https://magazine.fastcompany.com/loc/FST/summersale',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [
      {
        url: '/technology',
        title: 'Technology'
      },
      {
        url: '/leadership',
        title: 'Leadership'
      },
      {
        url: '/entertainment',
        title: 'Entertainment'
      },
      {
        url: '/ideas',
        title: 'Ideas'
      },
      {
        external: true,
        url: 'www.fastcompany.com/videos',
        title: 'Video'
      },
      {
        external: true,
        url: 'news.fastcompany.com',
        title: 'News'
      }
    ]
  },
  fastcodesign: {
    logo: '//g.fastcompany.net/asset_files/-/2015/12/22/CODESIGN.svg',
    title: 'Co.Design',
    subscribeLink: 'https://magazine.fastcompany.com/loc/FST/summersale',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [
      {
        url: '/cities',
        title: 'Cities'
      },
      {
        url: '/graphics',
        title: 'Graphics'
      },
      {
        url: '/innovation-by-design',
        title: 'Innovation By Design'
      },
      {
        url: '/interactive',
        title: 'Interactive'
      },
      {
        url: '/product',
        title: 'Product'
      },
      {
        url: '/spaces',
        title: 'Spaces'
      }
    ]
  }
};

export default data;



// WEBPACK FOOTER //
// ./src/views/components/nav/nav_data.js